import React, { useState, useEffect } from 'react'
import ReusableDiv from 'src/helper/ReusableDiv'
import System from 'src/helper/system'
import Helper from 'src/helper/Helper'
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";
import { __remove, __set } from "src/store/axios_indicator";
import { useDesignHubStore } from "src/hooks/designHub";
import Constants from "src/helper/Constants";
import DOMAttachToSystem from 'src/captain/DOMAttachToSystem';
import HelperAnalyticsEvent from 'src/support/HelperAnalyticsEvent';

const Registration = () => {
    const [detailValidation, setDetailValidation] = useState({});
    const [__check] = useAxiosIndicatorCheck();
    const [{ }, { }, { register_user }] = useDesignHubStore();

    const modal = {
        company_name: "",
        telephone_number: "",
        first_name: "",
        last_name: "",
        email_address: "",
        email_updates: System.getCookie("_mkto_trk") !== undefined ? true : false,
        mkto_trk: System.getCookie("_mkto_trk") || "",
        speedboat: System.avUserInfoData.speedBoatAbbr,
        accept_soa_terms: false
    }
    const [userDetail, setUserDetail] = useState(modal);
    const [confirmEmail, setConfirmEmail] = useState("")
    const { translation: t } = System;
    const companyNamePattern = System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr) ? Constants.apacCompanyNamePattern : Constants.japanCompanyNamePattern
    const firstNamePattern = System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr) ? Constants.apacFirstNamePattern : Constants.japanFirstNamePattern

    const onValueChange = (field, value) => {
        if (detailValidation && Object.keys(detailValidation).length > 0) {
            field === 'confirmEmail' ? delete detailValidation.confirm_email : delete detailValidation[field]
        }
        field === 'confirmEmail' ? setConfirmEmail(value) : setUserDetail({ ...userDetail, [field]: value });
    }

    const onValidateData = () => {
        let validationModal = {}
        Helper.valueIsNotNull(userDetail.company_name) ? (!Helper.validateRegex(userDetail.company_name, companyNamePattern) ? validationModal.company_name = t('companyNameEnglishValidation') : "") : validationModal.company_name = t('pleaseEnterACompanyName');

        Helper.valueIsNotNull(userDetail.telephone_number) ? (!Helper.validateRegex(userDetail.telephone_number, Constants.phoneNumberPattern) ? validationModal.telephone_number = t('pleaseEnterAValidPhoneNumber') : "") : validationModal.telephone_number = t('pleaseEnterAValidPhoneNumber');

        Helper.valueIsNotNull(userDetail.first_name) ? (userDetail.first_name?.length < 2 ? validationModal.first_name = t('firstNameMustNotBeLessThan2Char') : (!Helper.validateRegex(userDetail.first_name, firstNamePattern) ? validationModal.first_name = t('firstNameEnglishValidation') : "")) : validationModal.first_name = t('pleaseEnterAFirstName');

        Helper.valueIsNotNull(userDetail.last_name) ? (userDetail.last_name?.length < 2 ? validationModal.last_name = t('lastNameMustNotBeLessThan2Char') : (!Helper.validateRegex(userDetail.last_name, Constants.apacFirstNamePattern) ? validationModal.last_name = t('lastNameMustBeEnteredValidation') : "")) : validationModal.last_name = t('pleaseEnterLastName');

        const email_address = Helper.valueIsNotNull(userDetail?.email_address) ? userDetail.email_address?.trim?.() : "";

        Helper.valueIsNotNull(confirmEmail) ? (email_address?.toLocaleLowerCase() === confirmEmail?.toLocaleLowerCase() ? '' : validationModal.confirm_email = t('emailIdMismatch')) :
            validationModal.confirm_email = t('pleaseEnterValidEmailAddress');

        if (email_address) {
            if (!Constants.registerEmailPattern.test(email_address)) {
                validationModal.email_address = t('aValidEmailAddressIsRequired')
            }
        } else {
            validationModal.email_address = t('pleaseEnterValidEmailAddress');
        }

        userDetail.accept_soa_terms === true ? "" : validationModal.accept_soa_terms = t('pleaseSelectThisCheckbox');

        setDetailValidation(validationModal)
        return Object.keys(validationModal).length <= 0;
    }

    const onSubmit = async () => {
        let isValid = onValidateData();

        if (isValid) {
            __set('REGISTRATION_API_CALL')
            let validationModal = {}

            const payload = {
                ...userDetail,
                company_name: userDetail.company_name?.trim(),
                first_name: userDetail.first_name?.trim(),
                last_name: userDetail.last_name?.trim(),
                telephone_number: userDetail.telephone_number?.trim()
            }

            const res = await register_user(payload)
            if (res && res?.isSuccessFull) {
                System.popup('ThankYouPopup', { isRegister: true });
                HelperAnalyticsEvent.registrationComplete({ userId : res?.data})
            } else if (res?.errorCode === Constants.errorCode.UserExist001) {
                validationModal.email_address = t('accountAlreadyExists')
                setDetailValidation(validationModal)
            } else if (res.status === 400) {
                validationModal.company_name = res?.errors?.company_name?.[0]
                validationModal.telephone_number = res?.errors?.telephone_number?.[0]
                validationModal.first_name = res?.errors?.first_name?.[0]
                validationModal.last_name = res?.errors?.last_name?.[0]
                validationModal.email_address = res?.errors?.email_address?.[0]
                validationModal.confirmEmail = res?.errors?.confirmEmail?.[0]
                setDetailValidation(validationModal)
            }
            else {
                if (res && res.ErrorCode && res.Message) {
                    if (res?.ErrorCode === Constants.errorCode.error422) {
                        validationModal.email_address = t('pleaseUseYourWindowaCredToLogin')
                        setDetailValidation(validationModal)
                    }
                }
            }
            __remove('REGISTRATION_API_CALL')
        }
    }
    useEffect(() => {
        formStart()
    }, [])

    const formStart = () => {
        let formDetails = {
            formName: "Register",
            formType: "Registration",
            formId: ""
        }
        HelperAnalyticsEvent.formStart({ formDetails })
        HelperAnalyticsEvent.registrationStart();
    }

    const formError = () => {

    }

    return (
        <div>
            {process.env.NODE_ENV !== "development" && <DOMAttachToSystem />}
            <div className='register-container'>
                <div className='white-bg'>

                    {ReusableDiv.PopupTitle(t('joinNow'))}
                    <div>
                        <form>
                            <div className=" bs5 row">
                                <div className="col-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="company_name" className='d-block'>{t('companyName')}*</label>
                                        <input type="text" className={`form-control ${detailValidation && detailValidation.company_name ? ' error' : ''}`} id="company_name"
                                            placeholder={t('companyNamePH')} name="company_name"
                                            value={userDetail.company_name}
                                            maxLength={35}
                                            onChange={({ target: { value } }) => onValueChange('company_name', value)} />
                                        {detailValidation.company_name && <p className="error"> {detailValidation.company_name}</p>}
                                    </div>
                                </div>

                                <div className="col-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="telephone_number" className='d-block'>{t('phoneNumber')}*</label>
                                        <input type="text" className={`form-control ${detailValidation && detailValidation.telephone_number ? ' error' : ''}`} id="telephone_number"
                                            placeholder={t('phoneNumberPH')} name="telephone_number"
                                            value={userDetail.telephone_number}
                                            maxLength={25}
                                            onChange={({ target: { value } }) => onValueChange('telephone_number', value)} />
                                        {detailValidation.telephone_number && <p className="error"> {detailValidation.telephone_number}</p>}
                                    </div>
                                </div>
                            </div>
                            <div className=" bs5 row">
                                <div className="col-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="first_name" className='d-block'>{t('firstName')}*</label>
                                        <input type="text" className={`form-control ${detailValidation && detailValidation.first_name ? ' error' : ''}`} id="first_name"
                                            placeholder={t('firstNamePH')} name="first_name"
                                            value={userDetail.first_name}
                                            onChange={({ target: { value } }) => onValueChange('first_name', value)} maxLength={35} />
                                        {detailValidation.first_name && <p className="error"> {detailValidation.first_name}</p>}
                                    </div>
                                </div>

                                <div className="col-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="last_name" className='d-block'>{t('lastName')}*</label>
                                        <input type="text" className={`form-control ${detailValidation && detailValidation.last_name ? ' error' : ''}`} id="last_name"
                                            placeholder={t('lastNamePH')} name="last_name"
                                            value={userDetail.last_name}
                                            onChange={({ target: { value } }) => onValueChange('last_name', value)} maxLength={35} />
                                        {detailValidation.last_name && <p className="error"> {detailValidation.last_name}</p>}
                                    </div>
                                </div>
                            </div>
                            <div className=" bs5 row">
                                <div className="col-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="email_address" className='d-block'>{t('emailAddress')}*</label>
                                        <input type="text" className={`form-control ${detailValidation && detailValidation.email_address ? ' error' : ''}`} id="email_address"
                                            placeholder={t('emailAddressPH')} name="email_address"
                                            value={userDetail.email_address}
                                            onChange={({ target: { value } }) => onValueChange('email_address', value?.trim())} maxLength={70} />
                                        {detailValidation.email_address && <p className="error"> {detailValidation.email_address}</p>}
                                    </div>
                                </div>
                                <div className="col-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="confirmEmail" className='d-block'>{t('confirmEmail')}*</label>
                                        <input type="text" className={`form-control ${detailValidation && detailValidation.confirm_email ? ' error' : ''}`} id="confirmEmail"
                                            placeholder={t('confirmEmailPH')} name="confirmEmail"
                                            value={confirmEmail}
                                            onChange={({ target: { value } }) => onValueChange('confirmEmail', value?.trim())} maxLength={70} />
                                        {detailValidation.confirm_email && <p className="error"> {detailValidation.confirm_email}</p>}
                                    </div>
                                </div>
                            </div>

                            <div className='mb-3 d-flex align-items-center text-black'>
                                <input type="checkbox" className="form-check-input mt-0 me-2" id="customCheck1" name="email_updates" checked={userDetail.email_updates}
                                    onChange={({ target: { checked } }) => onValueChange('email_updates', checked)} />
                                <label for="customCheck1" className='cursor-pointer mb-0'>{t('receiveUpdatesFromAvnet')} </label>
                            </div>
                            <div className='mb-3 text-black'>
                                <div className='d-flex align-items-center'>
                                    <input type="checkbox" className={`form-check-input mt-0  me-2 ${detailValidation?.accept_soa_terms ? ' error' : ''}`} id="customCheck2" name="accept_soa_terms"
                                        onChange={({ target: { checked } }) => onValueChange('accept_soa_terms', checked)} />
                                    <label for="customCheck2" className='cursor-pointer mb-0'>{t('acceptSoaTermsToRegister')} </label>&nbsp;
                                    <a target={"_blank"} onClick={() => System.popup('SoATermsPopup')}>{t('viewSoaTerms')}</a> *
                                </div>
                                {detailValidation.accept_soa_terms && <p className="error"> {detailValidation.accept_soa_terms}</p>}
                            </div>

                            <p className='text-black'>{t('byRegisteringYouAgreeToOur')} {' '}
                                <a target={"_blank"} href={System.getTermsAndConditionURL()}>{t('termsAndConditions')}</a> {t('and')} {' '}
                                <a target={"_blank"} href={System.getPrivacyURL()}>{t('privacyStatement')}</a> {t('iAgree')}
                            </p>
                        </form>
                    </div>
                    <div className="d-flex justify-content-center mt-4 mb-4">
                        <button type="button" className="bs5 btn btn-secondary w145" onClick={() => { if (!__check(['REGISTRATION_API_CALL']).status) { window.location.href = System.getPreviousPageUrl() } }}
                        >{t('cancel')}</button>
                        <button type="button" className="bs5 btn btn-primary ms-3 w145" onClick={() => !__check(['REGISTRATION_API_CALL']).status && onSubmit()}
                        > {__check(['REGISTRATION_API_CALL']).status ? <i className="fa fa-spinner fa-spin" /> : t('submit')} </button>
                    </div>

                    <p className="d-flex mt-2 justify-content-center"> {t('alreadyACustomer')} &nbsp;
                        <a href={System.getLoginPageUrl()} className='text-decoration-underline'>{'  '}{t('signIn')}</a>
                    </p>
                </div>
                <div className='d-flex align-items-center justify-content-between'>
                    <a href={System.getPreviousPageUrl()} className='mt-3 mb-3'>{System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr) ? t('continueToAvnetApacHome') : t('continueToAvnetJapanHome')}</a>
                    <a href={System.getHelpPageURL()} className='mt-3 mb-3'>{t('help')}</a>
                </div>
            </div>

        </div>
    )
}

export default Registration
